// import logo from "./logo.svg";
// import Button from "react-bootstrap/Button";
import React, { useState } from "react";

import "./App.css";

import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";

import { InvitationDoctorSave, Main, Home } from "./pages/index";
import { Routes } from "react-router-dom/dist";
import TermsOfService from "./pages/privacy/TermsOfService";
import PrivacyPolicy from "./pages/privacy/PrivacyPolicy";
import Notice from "./pages/help/Notice";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Main />} exact={true} />
        <Route path="/home" element={<Home />} exact={true} />
        <Route
          path="/invitationDoctor/:id/:hid/:code"
          element={<InvitationDoctorSave />}
          exact={true}
        />
        {/* <Route
          path="/termsOfService"
          element={<TermsOfService />}
          exact={true}
        />
        <Route path="/privacyPolicy" element={<PrivacyPolicy />} exact={true} />
        <Route path="/notice" element={<Notice />} exact={true} /> */}
      </Routes>
    </Router>
  );
}
export default App;
